<template>
  <div id="func-8" style="min-height: 99vh">
    <FuncionalidadeHeader
      :titulo="contato.descricao"
    />
    <el-row class="row-contatos">
      <el-col class="col-13" :span="12">
        <div v-if="!open" class="contatos">
          <p class="contatos-titulo">{{label}}</p>
          <div class="contatos-itens" v-for="(subitem, i) in contatos" :key="i">
            <el-row>
              <el-col style="display: flex; align-items: center;" :span="20">
                <el-col :span="2" class="icone">
                  <svgIcone :icone="showIcone(subitem.tipo)" cor="#DDDDDD"></svgIcone>
                </el-col>
                <el-col :span="22" class="contatos-itens">
                  <span style="font-weight: 600" v-if="subitem.label">{{subitem.label}}</span>
                  <span class="value">{{subitem.value}}</span>
                </el-col>
              </el-col>
              <el-col :span="4">
                <a v-if="subitem.tipo  === 'telefone'" style="text-decoration: none" :href="`tel:+${subitem.value}`">
                  <el-button class="btn-link" type="text">{{titleButton(subitem.tipo)}}</el-button>
                </a>
                <a class="btn-link" v-if="subitem.tipo  === 'email'" :href="`mailto: ${subitem.value}`">
                  <el-button  v-if="subitem.tipo  === 'email'" type="text">{{titleButton(subitem.tipo)}}</el-button>
                </a>
                <a class="btn-link" :href="`${subitem.value}`" target="_blank">
                  <el-button v-if="subitem.tipo  === 'link'" type="text">{{titleButton(subitem.tipo)}}</el-button>
                </a>
                <el-button class="btn-link" v-if="subitem.tipo  === 'whatsapp'" @click="iniciarConversa(whatsapp)" type="text">{{titleButton(subitem.tipo)}}</el-button>
              </el-col>
            </el-row>
            <el-button type="text"></el-button>
          </div>
          <div class="contatos-itens">
            <el-row v-if="selectedItem.endereco">
              <el-col :span="20">
                <el-col :span="2" class="icone">
                  <svgIcone icone="icon_mini_map" cor="#DDDDDD"></svgIcone>
                </el-col>
                <el-col :span="22" class="contatos-itens">
                  <span style="font-weight: 600">{{selectedItem.endereco}}</span>
                </el-col>
              </el-col>
              <el-col :span="4">
                <el-button v-if="selectedItem.latitude" @click="open = true" type="text">Ver mapa</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <mapa v-if="open" :locations="dataMap" :config="mapConfig" @close="closeMap" :open-map="open"></mapa>
      </el-col>
      <el-col :span="12">
        <div class="line"></div>
        <div class="buttons">
          <el-button
            id="sideButton"
            ref="tabs"
            class="item-button"
            v-for="(item, index) in itensContato" :key="index"
            :class="{ active: index === activeItem }"
            @click="openIten(item, index)">
            <div class="text-side-button">
            <svg-icone fill="#006FB9" :width="10" class="svg-arrow" icone="Arrow_chevron"></svg-icone>
            <span class="text-button">{{item.descricao}}</span>
            </div>
          </el-button>
        </div>
        <div class="banner_image" v-if="contato.url_imagem">
          <img class="banner" :src="contato.url_imagem"/>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader.vue'
import Mapa from '@/components/mapa/Mapa'
export default {
  components: {
    FuncionalidadeHeader,
    Mapa
  },
  data () {
    return {
      open: false,
      dataMap: {},
      copiado: false,
      contato: {},
      Id: '',
      itensContato: [],
      selectedItem: {},
      contatos: [],
      label: '',
      activeItem: null,
      whatsapp: '',
      mapConfig: {
        open: false,
        showHeader: true,
        height: '634px',
        zoom: 15
      }
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade'])
  },
  methods: {
    async init () {
      let result = await this.apiFuncionalidade.lista({ loading: true })
      let contatos = result.data
      let index = contatos.findIndex(cont => cont.id === this.Id)
      this.contato = contatos[index]
      this.itensContato = this.contato.itens
      this.openIten(this.itensContato[0], 0)
      let i = this.contatos.findIndex(cont => cont.tipo === 'whatsapp')
      if (i !== -1) {
        this.whatsapp = this.contatos[i].value
      }
    },
    openIten (item, index) {
      this.activeItem = index
      this.selectedItem = {}
      this.contatos = []
      this.selectedItem = item
      this.contatos = item.contatos
      this.label = item.descricao
      let latitude = parseFloat(item.latitude)
      let longitude = parseFloat(item.longitude)
      this.dataMap = [{
        coordenadas: [{ lat: latitude, long: longitude }],
        descricao: item.descricao,
        endereco: item.endereco
      }]
    },
    closeMap () {
      this.open = false
    },
    iniciarConversa (numero) {
      let num = numero.replace(/[^\d]+/g, '')
      window.open('https://wa.me/55' + num)
    },
    titleButton (tipo) {
      let link = ''
      if (tipo === 'telefone') {
        link = 'Ligar'
      }
      if (tipo === 'whatsapp') {
        link = 'Conversar'
      }
      if (tipo === 'email') {
        link = 'e-mail'
      }
      if (tipo === 'link') {
        link = 'Abrir Link'
      }
      return link
    },
    showIcone (tipo) {
      let icone = ''
      if (tipo === 'telefone') {
        icone = 'icon_mini_phone'
      }
      if (tipo === 'whatsapp') {
        icone = 'icon_mini_whatsapp'
      }
      if (tipo === 'email') {
        icone = 'icon_mini_email'
      }
      if (tipo === 'link') {
        icone = 'icon_mini_open_new'
      }
      if (tipo === 'texto_livre') {
        icone = 'icon_mini_info'
      }
      return icone
    }
  },
  async created () {
    this.Id = parseInt(this.$route.query.idContato)
    await this.init()
    this.whatsapp.replace(/[^\d]+/g, '')
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.item-button {
  display: block;
  margin-bottom: 5px;
  width: 95%;
  margin-left: 0px;
  padding: 15px;
  text-transform: none;
  border-radius: 10px;
  background-color: #006FB914;
  color: #333333;
  font-weight: 600;
  border: none;
  font-size: 14px;
  float: right;
  position: relative;
}
.banner_image {
  display: block;
  margin-left: 0px;
  padding: 15px;
  position: relative;
  float: right;
  width: 65%;
}
.banner {
  float: right;
  border-radius: 10px;
  width: 95%;
  margin-right: 15px;
}
.text-button {
  float: left;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn-link    {
  font-family: "Open Sans";
}
.active {
  background-color: #FFFFFF;
  border: 2px solid #006FB914;
  width: 100%;
}
.text-side-button {
  display: flex;
  align-items: center;
}
.svg-arrow {
  transform: rotate(180deg);
  float: left;
  bottom: 1px;
  position: relative;
}
.contatos {
  margin-left: 20px;
}
.contatos-itens {
  display: grid;
}
.contatos-titulo {
  margin-top: 0;
  margin-bottom: 25px;
  color: #333333;
  font-size: 20px;
}
.line {
  height: 100%;
  border-right: 1px solid #EEEEEE;
  float: left;
  position: fixed;
  margin-top: -21px;
  margin-left: 13%;
}
.col-13::after {
  border-left: 1px solid black;
}
.value {
  color: #555555;
  font-size: 12px;
}
.row-contatos {
  margin-top: 20px;
  height: 99vh;
  max-height: 826px
}
.buttons {
  float: right;
  position: relative;
  right: 30px;
  width: 65%;
}
.col-13 {
  border-right: 1px solid #EEEEEE1f;
}
</style>
